module.exports = __webpack_public_path__ + "static/media/home.41b6dac0.png";